export enum TaskType {
  Form = 'form',
  Query = 'query',
  Reader = 'reader',
  Upload = 'upload',
}

export enum TaskParentContainerType {
  Acquisition = 'acquisition',
  File = 'file',
  Project = 'project',
  Session = 'session',
  Subject = 'subject',
}

export enum TaskFacet {
  Status = 'status',
  Priority = 'priority',
}

export enum ReaderTaskContainerType {
  Session = 'session',
  Acquisition = 'acquisition',
  File = 'file',
}

export enum TaskPriority {
  Blocker = 'blocker',
  High = 'high',
  Medium = 'medium',
  Low = 'low',
}

export enum TaskStatus {
  Cancelled = 'cancelled',
  Complete = 'completed',
  InProgress = 'in_progress',
  Todo = 'todo',
}

export const taskStatusLabel: Record<TaskStatus, string> = {
  [TaskStatus.Cancelled]: 'Cancelled',
  [TaskStatus.Complete]: 'Complete',
  [TaskStatus.InProgress]: 'In Progress',
  [TaskStatus.Todo]: 'To-Do',
}

export enum TaskAssigneeType {
  StaffingPool = 'staffing_pool',
  User = 'user',
}
